import { render, staticRenderFns } from "./CurrencySlider.vue?vue&type=template&id=223503eb&scoped=true&"
import script from "./CurrencySlider.vue?vue&type=script&lang=js&"
export * from "./CurrencySlider.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CurrencySlider.vue?vue&type=style&index=1&id=223503eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223503eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
